import script from "./RunRepo.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunRepo.vue?vue&type=script&setup=true&lang=ts"

import "./RunRepo.vue?vue&type=style&index=0&id=2054a45b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2054a45b"]])

export default __exports__